import {Container as BaseContainer} from '@nfq/react-grid';
import styled from 'styled-components';

export const Container = styled(BaseContainer)`
    max-width: 1686px;
    padding: 0;
    width: 100%;
`;